import { render, staticRenderFns } from "./CurrentBranchSelect.vue?vue&type=template&id=c77ea312&"
import script from "./CurrentBranchSelect.vue?vue&type=script&lang=js&"
export * from "./CurrentBranchSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports